import i18n from "@/i18n";
import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";


export default {
    namespaced: true,
    state: {
        accruals: [],
    },
    mutations: {
        setAccruals(state, newData) {
            state.accruals = newData;
        },
        addAccrual(state, newData) {
            state.accruals.push(newData);
        },
        updateAccrual(state, newData) {
            const targetAccrualIndex = state.accruals.findIndex(accrual => accrual.id === newData.id);
            state.accruals[targetAccrualIndex] = newData;
        },
    },
    actions: {
        async getAccruals({commit, rootState}, data) {
            const {personalData, company} = rootState;
            const {targetPeriod} = data;
            const url = `${URLS.MODEL.ACCRUAL.ACCRUALS_URL}?target_period=${targetPeriod}`;
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("setAccruals", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createAccrual({commit, rootState}, data) {
            const {personalData, company, schedule} = rootState;
            const {items, target_period, note} = data;
            const url = URLS.MODEL.ACCRUAL.ACCRUALS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    items: items,
                    target_period: target_period,
                    note: note,
                }),
                credentials: "include",
            };
            const successfulHandler = (data) => {
                if (data["accrual_data"]["target_period"] === schedule.currentSchedulePeriod.date) {
                    commit("addAccrual", data["accrual_data"]);
                    commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                }
                notify(i18n.global.t("Accrual successfully created"), "black", 3000);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async deleteAccrual({commit, rootState}, accrualId) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.ACCRUAL.ACCRUAL_URL.replace("<ID>", accrualId);
            const options = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
            };
            const successfulHandler = (data) => {
                commit("updateAccrual", data["accrual_data"]);
                commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                notify(i18n.global.t("Accrual successfully deleted"), "black", 3000);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};